
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';
import { getServiceList } from '@/api/service';

@Component({
  name: 'DialogSelectBranchServicer',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogBranchServicerVisible!: Boolean;

  created() {
    this.getList();
  }
  private searchServicer:any = {
    name: ''
  };
  private loading = false;
  private tableData = [];
  private radioServicer = '';
  private page=1
private loadMore = false;
private search() {
  this.page = 1;
  this.getList();
}

private resetSearch() {
  this.searchServicer = {
    name: ''
  };
  this.page = 1;
  this.getList();
}

private moreData() {
  this.page = this.page + 1;
  this.getList();
}
private getList() {
  this.loading = true;
  const params = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    servicer_company_name: (this.searchServicer && this.searchServicer.name) ? this.searchServicer.name : '',
    page: this.page,
    size: 10
  };
  getServiceList(params)
    .then((res) => {
      if (res && res.data) {
        if (this.page === 1) {
          this.tableData = res.data.list;
        } else {
          this.tableData = this.tableData.concat(res.data.list);
        }
        if (res.data.page_count > res.data.page_current) {
          this.loadMore = true;
        } else {
          this.loadMore = false;
        }
      } else {
        this.loadMore = false;
        this.tableData = [];
      }
      this.loading = false;
    })
    .catch((err) => {
      this.loadMore = false;
      this.tableData = [];
      let msg = (err.msg);
    });
}

private handleSearch() {
  this.getList();
}

private handleClear() {
  this.searchServicer = '';
  this.getList();
}

handleSubmit() {
  if (this.radioServicer === '') {
    this.$notify({
      title: '提示',
      message: '请选择服务方',
      duration: 3000,
      offset: 100,
      type: 'error'
    });
    return;
  }
  this.$emit('selectedbs', this.radioServicer);
}

private close() {
  this.$emit('close', false);
}

private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
}
